import { FC, SVGProps } from 'react';

const MultiStarsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 16, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M9.7646 2L10.9085 5.09138L13.9999 6.23529L10.9085 7.3792L9.7646 10.4706L8.62066 7.3792L5.5293 6.23529L8.62066 5.09138L9.7646 2Z"
        stroke="#2D2D2D"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.47059 9.05893L5.46985 10.5303L6.9412 11.5295L5.46985 12.5288L4.47059 14.0001L3.47132 12.5288L2 11.5295L3.47132 10.5303L4.47059 9.05893Z"
        stroke="#2D2D2D"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MultiStarsIcon;
